import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "../../../common/components/form";
import WebsiteColorPicker from "../Website/WebsiteColorPicker.jsx";

export default function PreviewBar(props) {
    const { t } = useTranslation();

    const refEditColorButton = React.useRef(null);
    const refColorPicker = React.useRef(null);
    const refDots = React.useRef(null);

    const loading = props.loading !== undefined && props.loading;

    const {
        onBackClick,
        onCancelClick,
        onEditColorClick,

        onEditDesignClick,
        disableEditDesign,

        onEditContentClick,
        onEditECommerceClick,
        onSaveClick,
        onSavePublishClick,
        onPublishClick,

        variables,
        showPicker,
        onColorDefault,
        onColorApply,
    } = props;

    React.useEffect(() => {
        return DynamicHeaderDots();
    }, [disableEditDesign, loading]);

    function DynamicHeaderDots() {
        if (!refDots.current) {
            return;
        }

        const domSpanList = Object?.values(refDots?.current?.querySelectorAll("span"));
        const spanCount = domSpanList.length;

        let currentDotIndex = spanCount - 1;
        function next() {
            for (const domDot of domSpanList) {
                domDot.classList.remove("show");
            }

            const nextDomDot = domSpanList[currentDotIndex + 1] ?? domSpanList[0];
            currentDotIndex = domSpanList.indexOf(nextDomDot);
            nextDomDot.classList.add("show");
        }

        next();
        const intervalId = setInterval(next, 250);

        return () => {
            clearInterval(intervalId);
        };
    }

    const colorEditing = variables && onEditColorClick && onColorDefault && onColorApply;

    React.useEffect(() => {
        const btn = refEditColorButton.current;
        const pckr = refColorPicker.current;

        if (!btn || !pckr) {
            return;
        }

        const bbb = btn.getBoundingClientRect();
        const pbb = pckr.getBoundingClientRect();

        const x = bbb.left + bbb.width / 2;
        const y = bbb.top + bbb.height;

        pckr.style.setProperty("top", `${Math.max(0, Math.min(window.innerHeight - pbb.height, y))}px`);
        pckr.style.setProperty("left", `${Math.max(0, Math.min(window.innerWidth - pbb.width, x - pbb.width / 2))}px`);

        pckr.classList[showPicker ? "add" : "remove"]("active");
    }, [showPicker]);

    return (
        <>
            <div className="preview-bar">
                {!loading && (
                    <>
                        {onBackClick && (
                            <ButtonBase invert dashed onClick={onBackClick}>
                                {t("Back")}
                            </ButtonBase>
                        )}

                        {onCancelClick && (
                            <ButtonBase invert dashed onClick={onCancelClick}>
                                {t("Cancel")}
                            </ButtonBase>
                        )}

                        {colorEditing && (
                            <div ref={refEditColorButton}>
                                <ButtonBase className="w100" invert onClick={onEditColorClick}>
                                    <div className="website-edit-color-button">
                                        <div
                                            className="website-edit-color-button-selected"
                                            style={{
                                                display: variables?.color?.userPrimary ? "block" : "none",
                                                backgroundColor: variables?.color?.userPrimary,
                                            }}
                                        ></div>

                                        <div>{t("EditColor")}</div>
                                    </div>
                                </ButtonBase>
                            </div>
                        )}

                        {onEditDesignClick && (
                            <ButtonBase className="relative" invert onClick={onEditDesignClick}>
                                {!disableEditDesign && t("EditDesign")}

                                {disableEditDesign && (
                                    <span ref={refDots} className="previev-bar-designing-dots">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>
                                )}
                            </ButtonBase>
                        )}

                        {onEditContentClick && (
                            <ButtonBase invert onClick={onEditContentClick}>
                                {t("EditContent")}
                            </ButtonBase>
                        )}

                        {onEditECommerceClick && (
                            <ButtonBase invert onClick={onEditECommerceClick}>
                                {t("EditECommerce")}
                            </ButtonBase>
                        )}

                        {onSaveClick && (
                            <ButtonBase invert onClick={onSaveClick}>
                                {t("Save")}
                            </ButtonBase>
                        )}

                        {onPublishClick && (
                            <ButtonBase invert solid onClick={onPublishClick}>
                                {t("Publish")}
                            </ButtonBase>
                        )}

                        {onSavePublishClick && (
                            <ButtonBase invert solid onClick={onSavePublishClick}>
                                {t("SavePublish")}
                            </ButtonBase>
                        )}
                    </>
                )}
            </div>

            {colorEditing && (
                <div ref={refColorPicker} className="website-design-color-editor">
                    {(variables?.color?.userPrimary ?? variables?.color?.primary) && (
                        <WebsiteColorPicker
                            color={variables?.color?.userPrimary ?? variables?.color?.primary ?? null}
                            onDefault={onColorDefault}
                            onApply={onColorApply}
                        />
                    )}
                </div>
            )}
        </>
    );
}
